import { useState, type FormEvent } from "react";

interface CreditDialogProps {
  userName: string;
  onConfirm: (amount: number, reason: string) => Promise<void>;
  onCancel: () => void;
}

export function CreditDialog({ userName, onConfirm, onCancel }: CreditDialogProps) {
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const num = parseInt(amount, 10);
    if (!num || num === 0) return;
    setLoading(true);
    await onConfirm(num, reason);
    setLoading(false);
  };

  const parsed = parseInt(amount, 10);
  const isRemove = parsed < 0;
  const isValid = !isNaN(parsed) && parsed !== 0;

  return (
    <div className="dialog-overlay" onClick={onCancel}>
      <form className="dialog" onClick={(e) => e.stopPropagation()} onSubmit={handleSubmit}>
        <h2>Adjust Credits</h2>
        <p style={{ color: "var(--text-secondary)", fontSize: 13, marginBottom: 20 }}>
          {isRemove ? "Removing" : "Granting"} credits {isRemove ? "from" : "to"} <strong style={{ color: "var(--warm-white)" }}>{userName}</strong>
        </p>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", fontSize: 11, color: "var(--gold-muted)", letterSpacing: 1, textTransform: "uppercase", marginBottom: 6 }}>
            Credits (negative to remove)
          </label>
          <input
            className="input-field"
            type="number"
            placeholder="100 or -50"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            autoFocus
          />
        </div>

        <div style={{ marginBottom: 4 }}>
          <label style={{ display: "block", fontSize: 11, color: "var(--gold-muted)", letterSpacing: 1, textTransform: "uppercase", marginBottom: 6 }}>
            Reason
          </label>
          <textarea
            className="input-field"
            placeholder="e.g. Support ticket #1234"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        <div className="dialog-actions">
          <button type="button" className="btn-outline" onClick={onCancel}>
            Cancel
          </button>
          <button type="submit" className={isRemove ? "btn-outline" : "btn-gold"} style={isRemove ? { borderColor: "#e04040", color: "#e04040" } : undefined} disabled={loading || !isValid}>
            {loading ? (isRemove ? "Removing..." : "Granting...") : (isRemove ? `Remove ${Math.abs(parsed)} Credits` : "Grant Credits")}
          </button>
        </div>
      </form>
    </div>
  );
}
